import './CTAsList.css';
import React from 'react';
import { canUseDOM, get, getColorByTheme, getPageThemeColors } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import RouterLink from '../atoms/RouterLink';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
const CTAsList = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const variables = BackgroundColorHex ? {
    '--m36-background-color': BackgroundColorHex,
    '--m36-background-active-color': ActiveColorHex,
    '--m36-color': ColorHex
  } : {
    '--m36-background-color': primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    '--m36-background-active-color': primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active,
    '--m36-color': getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  if (!fields) {
    console.warn('CTAsList component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [CTAsList component is empty: please provide data source]");
    }
    return null;
  }
  const threeColumns = params !== undefined && params['Position'] === 'Three Columns' ? true : false;
  const hasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  const hasItems = Boolean(get(fields, 'data.item.links.length'));
  const hasButton = Boolean(get(fields, 'data.item.ctaLabel.jss.value'));
  const buttonText = hasButton ? get(fields, 'data.item.ctaLabel.jss.value', '') : '';
  const buttonLink = get(fields, 'data.item.cTALink.jss.value');
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    style: variables
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    className: "h3 CTAsList-links_heading",
    tag: "h3",
    field: fields.data.item.title.jss
  }), hasItems && /*#__PURE__*/React.createElement("ul", {
    className: "CTAsList-links_list"
  }, fields.data.item.links.map(item => item.ctaLabel && item.cTALink && item.cTALink.jss.value.href && /*#__PURE__*/React.createElement("li", {
    className: `CTAsList-links_li ${threeColumns ? 'CTAsList-links_li_three_columns' : 'CTAsList-links_li_two_columns'}`,
    key: item.ctaLabel.jss.value
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "CTAsList-links_a theme-contrast",
    title: item.ctaLabel.jss.value,
    href: item.cTALink.jss.value.href,
    linktype: item.cTALink.jss.value.linktype,
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), [fields.data.item.title.jss.value, item.ctaLabel.jss.value])
  }, item.ctaLabel.jss.value, item.iconType.targetItem.icon.jss.value && /*#__PURE__*/React.createElement("div", {
    className: "CTAsList-links_icon",
    dangerouslySetInnerHTML: {
      __html: item.iconType.targetItem.icon.jss.value
    }
  }))))), buttonLink && buttonLink.href && buttonText && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn btn-primary CTAsList-links_btn",
    title: buttonText,
    href: buttonLink.href,
    linktype: buttonLink.linktype,
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), [fields.data.item.title.jss.value, buttonText])
  }, buttonText)));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "c12pztnm";
const ltrStyles = "ljqlk2";
const rtlStyles = "rjyrggf";
export default CTAsList;